export default (props, vars) => props?.['student']?.majors || '—';
